import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Gallery = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    axios.get(`${API}/gallery`).then((r) => setImages(r.data)).catch(console.error);
  }, []);

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <span className="section-label">Gallery</span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter text-white mt-4 mb-4 max-w-2xl">
          Moments from <span className="gradient-text">past summits</span>
        </h2>
        <p className="text-zinc-400 text-base sm:text-lg mb-16 max-w-xl leading-relaxed">
          Highlights from our previous events showcasing impactful sessions, workshops, and community engagement.
        </p>

        {/* Bento Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 stagger-children">
          {images.map((img, i) => (
            <div
              key={img.id}
              className={`gallery-item relative group bg-zinc-900 border border-zinc-800 overflow-hidden ${
                i === 0 ? "sm:col-span-2 sm:row-span-2" : ""
              }`}
              data-testid={`gallery-item-${img.id}`}
            >
              <div className={`${i === 0 ? "aspect-square" : "aspect-[4/3]"}`}>
                <img
                  src={img.url}
                  alt={img.caption}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-5">
                <div>
                  <p className="text-white text-sm font-semibold">{img.caption}</p>
                  <p className="text-zinc-400 text-xs mt-1">{img.year}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
